import React from 'react'
import mount from '../lib/mount'
import Heart from '../components/Heart'

// Heart component doesn't require redux.
document.addEventListener('turbolinks:load', () => {
  const el = document.getElementById('react-heart')
  if (el) {
    const data = JSON.parse(el.getAttribute('data'))
    mount(
      el,
      <Heart
        count={data.count}
        hearted={data.hearted}
      />,
    )
  }
})
